module.exports = __webpack_public_path__ + "img/Contract_signing.adb363d3.jpg";